import React, { useEffect, useRef, useState } from 'react'
import ClickListener from '../../utils/useClickOutside'
import ImageLoader from './ImageLoader'
import Icon from '../Icon'
import './ImageInfoModal.scss'
import breakpoints from '../../styles/_theme.json'
import {validateItem, replaceMessageKeys} from './uploadUtils'


const ImageInfoModal = ({ onClose, iconRef, item, onDelete, onSelect, t, validation, uiSchema, defaultAssets }) => {
  const { assets: { getAsset } } = window.UStoreProvider.state
  const md = parseInt(breakpoints.md.replace('px', ''))
  const modalRef = useRef(null)
  const [errors, setErrors] = useState([])
  const [isMobile, setIsMobile] = useState(window.innerWidth < md)
  const [dimensions, setDimensions] = useState({ Width: item.Width, Height: item.Height })
  const [size, setSize] = useState(null)
  const [style, setStyle] = useState(isMobile ? {}: {
    top: '-99999em',
    left: '-99999em',
  })

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < md)
    }
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [item])


  useEffect(
    () => {
      (async () => {
        if (!item.isUeditAsset) {
          const asset = defaultAssets.find((asset) => asset.AssetID === item.AssetID) || await getAsset(item.AssetID)
          setDimensions({ Width: asset.Width || 0, Height: asset.Height || 0})
          setSize(asset.SizeKB)
          setErrors(replaceMessageKeys(validateItem(asset, validation), uiSchema))
        }
      })()

      if (!isMobile) {
        const { width: modalWidth, height: modalHeight } = modalRef.current.getBoundingClientRect()
        const { x, y, width, height } = iconRef.current.getBoundingClientRect()
        const newModalLocation = {
          top: y + height / 2,
          left: x + width / 2
        }
        if (newModalLocation.left + modalWidth > window.innerWidth) {
          newModalLocation.left = x + width / 2 - modalWidth
        }
        // 30 is the height of the dimensions and size
        const modalHeightWithDetails = modalHeight + 30
        if (newModalLocation.top + modalHeightWithDetails > window.innerHeight) {
          newModalLocation.top = newModalLocation.top - modalHeightWithDetails
        }
        setStyle({ ...newModalLocation })
      }
    }, [])

  const onSelectHandler = () => onSelect({...item, ...dimensions, ...size})
  const onDeleteHandler = (e) => {
    e.stopPropagation()
    onDelete(e)
  }

  const validationClassSuffix = item.IsUploaded ? 'error' : 'warn'
  return (
    <ClickListener trigger={onClose}>
      <div className="xmp-gs-smi-backdrop" onClick={onClose}/>
      <div className="xmp-gs-smi" style={style} ref={modalRef}>
        <div className="xmp-gs-smi-close" onClick={onClose}>
          <Icon name="closeBig.svg" width="20px" height="20px"/>
        </div>
        <div className="xmp-gs-smi-image">
          <ImageLoader src={item.Url || item.ThumbnailUrl} scrollableRef={{current: document.body}}/>
        </div>
        <div className="xmp-gs-smi-details">
          <div className="xmp-gs-smi-details-name">
            <div>{item.FileName}</div>
            {item.IsUploaded && <Icon name="trash.svg" width="20px"
                                      height="20px"
                                      className="error-icon" onClick={onDeleteHandler}/>}
          </div>
          {dimensions.Width && dimensions.Width !== 0 && dimensions.Height && dimensions.Height !== 0 &&
            <div className="xmp-gs-smi-details-dim">{t('GallerySelectorDuc.Dimensions')} {dimensions.Width}px
              X {dimensions.Height}px</div>}
          {size && <div className="xmp-gs-smi-details-size">{t('GallerySelectorDuc.Size', {size})}</div>}
          {errors.length > 0 &&
            <div className={`xmp-gs-smi-details-validations xmp-gs-smi-details-${validationClassSuffix}`}>
              {errors.map(err => (<div className="xmp-gs-smi-details-validations-item">
                  <Icon name={`${ validationClassSuffix}.svg`} width="14px"
                        height="12px"
                        className="error-icon"/>{err}
              </div>))}
            </div>}
          <div className="xmp-gs-smi-select button button-primary" onClick={onSelectHandler}>{t('GallerySelectorDuc.Select')}</div>
        </div>
      </div>
    </ClickListener>
  )
}

export default ImageInfoModal
